// Selector de descargas
export const selectTemplatesState = (state) => state.plantillas;

export const selectTemplateParamsState = (state) => state.plantillas.parameters;

export const selectTemplateFormState = (state) => state.plantillas.form;
